const apiErrorMappings = {
  customer_id: {
    'value not found': 'Pelanggan telah terhapus dari sistem',
  },
  vehicle_id: {
    'vehicle_id must be filled when driver_user_id or driver_user_2_id is filled':
      'Kolom Kendaraan wajib diisi terlebih dahulu',
  },
  third_party_id: {
    'value not unique': 'ID Referensi sudah terdaftar di sistem.',
  },
  custodian_id: {
    'value not found': 'Penanggung jawab tidak ditemukan di sistem',
  },
}

export default apiErrorMappings
